import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type RequestRampPurchaseOrderCopyMutationVariables = Types.Exact<{
  input: Types.RequestRampPurchaseOrderCopyInput;
}>;


export type RequestRampPurchaseOrderCopyMutation = { __typename?: 'Mutation', requestRampPurchaseOrderCopy: { __typename?: 'RampPurchaseOrderCopyPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null, rampPurchaseOrderCopy?: { __typename?: 'RampPurchaseOrderCopyData', purchaseOrderId: string, operation: Types.RampPurchaseOrderCopyOperation, status: Types.RampPurchaseOrderCopyStatus, notCopiedReason?: Types.RampPurchaseOrderNotCopiedReason | null, rampPurchaseOrderNumber?: string | null, rampPurchaseOrderUrl?: string | null, retryCount: number, errorMessage?: string | null, completedAt?: Types.TDateISO | null } | null } };


export const RequestRampPurchaseOrderCopyDocument = new TypedDocumentString(`
    mutation RequestRampPurchaseOrderCopy($input: RequestRampPurchaseOrderCopyInput!) {
  requestRampPurchaseOrderCopy(input: $input) {
    errors {
      code
      message
    }
    rampPurchaseOrderCopy {
      ...RampPurchaseOrderCopyFields
    }
  }
}
    fragment RampPurchaseOrderCopyFields on RampPurchaseOrderCopyData {
  purchaseOrderId
  operation
  status
  notCopiedReason
  rampPurchaseOrderNumber
  rampPurchaseOrderUrl
  retryCount
  errorMessage
  completedAt
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    RequestRampPurchaseOrderCopy: build.mutation<RequestRampPurchaseOrderCopyMutation, RequestRampPurchaseOrderCopyMutationVariables>({
      query: (variables) => ({ document: RequestRampPurchaseOrderCopyDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useRequestRampPurchaseOrderCopyMutation } = injectedRtkApi;
